import { createApiRef } from '@backstage/core-plugin-api';
import { FeatureFlagResult } from './types';
// import { FeatureFlagResult } from './types';

export const environmentConfigProviderApiRef =
  createApiRef<EnvironmentConfigProviderApi>({
    id: 'environment.config.provider',
  });

export interface environmentConfigProviderResponse<T> {
  response: Response;
  json: () => Promise<T>;
}

export type EnvironmentConfigProviderApi = {
  fetchFeatureFlag: (
    key: string,
  ) => Promise<environmentConfigProviderResponse<FeatureFlagResult>>;
};
